import { el } from "../utils";

export function renderNotFoundScreen(slug: string): HTMLElement {
  const screen = el("main", "screen not-found-screen");
  const shell = el("section", "not-found-shell");
  shell.append(el("p", "eyebrow", "Quiz not found"));
  shell.append(el("h1", "not-found-title", `No quiz is registered for /${slug}`));
  shell.append(el("p", "not-found-text", "Check the slug or add a quiz definition to the central registry."));
  const link = el("a", "primary-button", "Open demo quiz") as HTMLAnchorElement;
  link.href = "/demo";
  shell.append(link);
  screen.append(shell);
  return screen;
}
